import { ConfirmDialog } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

interface UnsavedChangesDialogProps {
    isOpen: boolean;
    /** Runs the navigation the reader asked for, discarding the changes. */
    onConfirm: () => void;
    /** Leaves everything where it was, changes included. */
    onCancel: () => void;
    /** Stacks the dialog above another modal, which the library sets at 50. */
    zIndex?: number;
    /** Names the way back when there is no page to stay on, only a form to return to. */
    cancelLabel?: string;
}

/** Stands between unsaved changes and any navigation that would throw them away. */
export const UnsavedChangesDialog = ({
    isOpen,
    onConfirm,
    onCancel,
    zIndex,
    cancelLabel,
}: UnsavedChangesDialogProps) => {
    const { t } = useAmelioTranslations();

    return (
        <ConfirmDialog
            isOpen={isOpen}
            title={t('common.unsavedChanges.title')}
            message={t('common.unsavedChanges.message')}
            confirmLabel={t('common.unsavedChanges.confirm')}
            cancelLabel={cancelLabel ?? t('common.unsavedChanges.cancel')}
            onConfirm={onConfirm}
            onCancel={onCancel}
            isDestructive
            zIndex={zIndex}
            dataTestId={'unsaved-changes-dialog'}
        />
    );
};
